angular.module('unica_workshop.workshop_controllers')

.controller('WorkshopEditController', function(
	$rootScope, $scope, $state, $stateParams,
	WorkshopEditService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getEventStages( $stateParams.event_id );

	$rootScope.getRelatorList();

	$rootScope.getTrackList( $stateParams.event_id );

	$rootScope.getWorkshop( $stateParams.id );

	$rootScope.workshopData = {
		event_id: $stateParams.event_id,
		filename_pre_event: '',
		filename_post_event: ''
	};

	$scope.saveWorkshop = function()
	{
		$scope.showLoader();

		var workshopData = angular.copy($rootScope.workshopData);

		WorkshopEditService
			.update( workshopData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {

					if ( $scope.uploader.queue.length > 0 ) {

						$scope.uploader.formData.push({ 'id' : data.id });

						var i = 0;
						for ( ; i < $scope.uploader.queue.length; i++ ) {
							$scope.uploader.queue[i].formData.push({ 'id' : data.id });
						}

						$scope.showLoader();
						$scope.uploader.uploadAll();
					} else {
						$scope.showSuccessMsg('Workshop aggiornato con successo!', '');
					}
				}
			});

	};

});